import { PureComponent } from 'react';
import Airport from '../../../../types/airport';
import { DispatchProp, connect } from 'react-redux';
import { RootState } from '../../../../reducers';

import { Popover } from 'antd';
import TooltipMaintenance from '../../../tooltip/vistajet/maintenance';
import { hasPermission } from '../../../../utils/check-permissions';
import { TooltipPlacement } from 'antd/lib/tooltip';
import '../styles.scss';
import Maintenance from '../../../../types/maintenance';
import { getMaintenanceSegmentBorderColor } from '../../../../common/maintenance/maintenance-colorization';
import { Header } from '../header';
import MaintenanceCardContent from './content';
import { AnyAction } from 'redux';

interface PreviewProps {
  isFocusing: boolean;
  isFocused: boolean;
  onFocus: () => void;
  onBlur: () => void;
  element: Maintenance;
  placement: TooltipPlacement;
}

interface StateProps {
  airportsById: { [id: string]: Airport };
  isHiddenTooltipWrapper: boolean;
  hasEditMxEventPermission: boolean;
  hasDeleteMxEventPermission: boolean;
}

class MaintenancePreviewCardComponent extends PureComponent<
  PreviewProps & StateProps & DispatchProp<AnyAction>
> {
  render() {
    const {
      element,
      airportsById,
      isFocused,
      isFocusing,
      onFocus,
      onBlur,
      placement = 'right',
      hasDeleteMxEventPermission,
      hasEditMxEventPermission,
    } = this.props;
    return (
      <Popover
        content={
          <TooltipMaintenance
            segmentData={element}
            airportsById={airportsById}
          />
        }
        overlayClassName="overlaped-popover"
        placement={placement}
      >
        <div
          className="card"
          style={{
            marginTop: 8,
            border: '1px solid #DDDDDD',
            borderRadius: 4,
            opacity: !isFocusing || isFocused ? 1 : 0.3,
          }}
          onMouseEnter={onFocus}
          onMouseLeave={onBlur}
        >
          <Header
            height={6}
            colors={[
              getMaintenanceSegmentBorderColor(
                element.maintenanceOrderType,
                element.maintenanceType
              ),
            ]}
          />
          <MaintenanceCardContent
            element={element}
            airportsById={airportsById}
            hasDeleteMxEventPermission={hasDeleteMxEventPermission}
            hasEditMxEventPermission={hasEditMxEventPermission}
          />
        </div>
      </Popover>
    );
  }
}

export const MaintenancePreviewCard = connect<StateProps>(
  (state: RootState) => ({
    airportsById: state.airports.airportsById,
    isHiddenTooltipWrapper: !hasSomePermissions(state),
    hasEditMxEventPermission: hasPermission(
      state,
      'AG-Timeline-Create-MX-Event'
    ),
    hasDeleteMxEventPermission: hasPermission(
      state,
      'AG-Timeline-Delete-MX-Event'
    ),
  })
)(MaintenancePreviewCardComponent);

function hasSomePermissions(state: RootState): boolean {
  return (
    hasPermission(state, 'AG-Timeline-Create-MX-Event') &&
    hasPermission(state, 'AG-Timeline-Delete-MX-Event')
  );
}
